import { httpClient } from "src/utils/HttpClient";
import Swal from "sweetalert2";

const {
  GET_BG_ADJ_PROJECT_FETCH,
  GET_BG_ADJ_PROJECT_SUCCESS,
  GET_BG_ADJ_PROJECT_REJECTED,
  GET_BG_ADJ_BUDGET_FETCH,
  GET_BG_ADJ_BUDGET_SUCCESS,
  GET_BG_ADJ_BUDGET_REJECTED,
  CREATE_BG_ADJ_SUCCESS,
  CREATE_BG_ADJ_REJECTED,
  GET_BG_ADJ_FETCH,
  GET_BG_ADJ_SUCCESS,
  GET_BG_ADJ_REJECTED,
  UPDATE_BG_ADJ_SUCCESS,
  UPDATE_BG_ADJ_REJECTED,
  GET_BUDGET_ADJ_REMAIN_REPORT_FETCH,
  GET_BUDGET_ADJ_REMAIN_REPORT_SUCCESS,
  GET_BUDGET_ADJ_REMAIN_REPORT_REJECTED,
  GET_BUDGET_ADJ_REMAIN_REPORT_CLEAR,
  apiUrl,
} = require("src/Constants");

export const getBudgetAdjRemain = ({
  PR_YEAR,
  PR_BRANDID,
  PR_DEPARTID,
  PR_COUNTRYID,
  PR_COMPANYID,
}) => {
  return async (dispatch) => {
    dispatch({
      type: GET_BUDGET_ADJ_REMAIN_REPORT_FETCH,
    });
    try {
      const result = await httpClient.get(
        `/budget-adjustment/budget-adjustment-remain/${PR_YEAR}/${PR_COMPANYID}/${PR_COUNTRYID}/${PR_BRANDID}/${PR_DEPARTID}`
      );
      dispatch({
        type: GET_BUDGET_ADJ_REMAIN_REPORT_SUCCESS,
        payload: result.data,
      });
    } catch (err) {
      dispatch({ type: GET_BUDGET_ADJ_REMAIN_REPORT_REJECTED });
    }
  };
};

export const clearBudgetAdjRemain = () => {
  return (dispatch) => {
    dispatch({ type: GET_BUDGET_ADJ_REMAIN_REPORT_CLEAR });
  };
};

export const getBudgetAdjustmentAll = (countryid) => {
  return async (dispatch) => {
    dispatch({ type: GET_BG_ADJ_FETCH });
    try {
      const result = await httpClient.get(
        `${apiUrl}/budget-adjustment/${countryid}`
      );
      dispatch({ type: GET_BG_ADJ_SUCCESS, payload: result.data });
    } catch (err) {
      dispatch({ type: GET_BG_ADJ_REJECTED });
    }
  };
};

export const getBudgetAdjustmentUser = (perid, countryid) => {
  return async (dispatch) => {
    dispatch({ type: GET_BG_ADJ_FETCH });
    try {
      const result = await httpClient.get(
        `${apiUrl}/budget-adjustment/task-user/${perid}/${countryid}`
      );
      dispatch({ type: GET_BG_ADJ_SUCCESS, payload: result.data });
    } catch (err) {
      dispatch({ type: GET_BG_ADJ_REJECTED });
    }
  };
};

export const getBudgetAdjustmentManager = (perid, countryid) => {
  return async (dispatch) => {
    dispatch({ type: GET_BG_ADJ_FETCH });
    try {
      const result = await httpClient.get(
        `${apiUrl}/budget-adjustment/task-manager/${perid}/${countryid}`
      );
      dispatch({ type: GET_BG_ADJ_SUCCESS, payload: result.data });
    } catch (err) {
      dispatch({ type: GET_BG_ADJ_REJECTED });
    }
  };
};

export const getBudgetAdjustmentVerifier = (countryid) => {
  return async (dispatch) => {
    dispatch({ type: GET_BG_ADJ_FETCH });
    try {
      const result = await httpClient.get(
        `${apiUrl}/budget-adjustment/task-verifier/${countryid}`
      );
      dispatch({ type: GET_BG_ADJ_SUCCESS, payload: result.data });
    } catch (err) {
      dispatch({ type: GET_BG_ADJ_REJECTED });
    }
  };
};

export const getBudgetAdjProject = (
  countryid,
  companyid,
  brandid,
  yearcode,
  departmentid
) => {
  return async (dispatch) => {
    dispatch({ type: GET_BG_ADJ_PROJECT_FETCH });
    try {
      const result = await httpClient.get(
        `${apiUrl}/budget-adjustment/projects/${countryid}/${companyid}/${brandid}/${yearcode}/${departmentid}`
      );
      dispatch({ type: GET_BG_ADJ_PROJECT_SUCCESS, payload: result.data });
    } catch (err) {
      dispatch({ type: GET_BG_ADJ_PROJECT_REJECTED });
    }
  };
};

export const getBudgetAdjTo = (budgetcode, projectcode) => {
  return async (dispatch) => {
    dispatch({ type: GET_BG_ADJ_BUDGET_FETCH });
    try {
      const result = await httpClient.get(
        `${apiUrl}/budget-adjustment/budgets/${budgetcode}/${projectcode}`
      );
      dispatch({ type: GET_BG_ADJ_BUDGET_SUCCESS, payload: result.data });
    } catch (err) {
      dispatch({ type: GET_BG_ADJ_BUDGET_REJECTED });
    }
  };
};

export const createBudgetAdj = (value, history) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.post(
        `${apiUrl}/budget-adjustment`,
        value
      );

      if (result.data) {
        Swal.fire({
          text: "Your document already submit. Waiting for Review.",
          icon: "success",
        }).then(() => {
          dispatch({ type: CREATE_BG_ADJ_SUCCESS, payload: result.data });
          history.replace(`/budget-adjustment-requisition`);
        });
      }
    } catch (err) {
      dispatch({ type: CREATE_BG_ADJ_REJECTED });
    }
  };
};

export const updateBudgetAdj = (value, history) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.put(
        `${apiUrl}/budget-adjustment/${value.ID}`,
        value
      );

      if (result.data) {
        let message = "";

        switch (value.STATUS) {
          case 1:
            message = "Your document already submit. Waiting for Review.";
            break;
          case 2:
            message = "Your document already submit. Waiting for Review.";
            break;
          case 3:
            message =
              "Document already reviewed. Now it sent to Finance verify data.";
            break;
          case 4:
            message =
              "The budget adjustment requisition already reviewer rejected.";
            break;
          case 5:
            message = "Document already verified.";
            break;
          case 6:
            message =
              "The budget adjustment requisition already verifier rejected.";
            break;
          case 7:
            message = "The budget adjustment requisition already cancelled.";
            break;
          default:
            message = "The budget adjustment requisition already save.";
            break;
        }

        Swal.fire({
          text: message,
          icon: "success",
        }).then(() => {
          dispatch({ type: UPDATE_BG_ADJ_SUCCESS, payload: result.data });
          history.replace(`/budget-adjustment-requisition`);
        });
      }
    } catch (err) {
      Swal.fire({
        text: "The budget adjustment requisition has error.",
        icon: "error",
      }).then(() => {
        dispatch({ type: UPDATE_BG_ADJ_REJECTED });
      });
    }
  };
};
